/*!
* @copyright
* Copyright(c) 2018 SICK AG
*/
const style = `* {
  box-sizing: border-box;
}

*,
:host {
  box-sizing: border-box;
  font-size: 1rem;
  font-family: inherit;
}

:host button,
:host input,
:host optgroup,
:host select,
:host textarea {
  font-family: inherit;
}

/* default */
:host {
  position: relative;
  font-weight: 700;
  background-color: #007CC1;
  background-color: var(--davinci-color-primary, #007CC1);
  border-color: #007CC1;
  border-color: var(--davinci-color-primary, #007CC1);
  color: #FFFFFF;
  color: var(--davinci-color-text-on-primary, #FFFFFF);
  fill: #FFFFFF;
  fill: var(--davinci-color-text-on-primary, #FFFFFF);
  contain: content;
  border-width: 0.0714285714rem;
  border-style: solid;
  display: inline-block;
  vertical-align: middle;
  cursor: pointer;
  -webkit-user-select: none;
     -moz-user-select: none;
      -ms-user-select: none;
          user-select: none;
  outline: 0;
  text-align: center;
  padding: 0 1.0714285714rem;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  height: 3.2857142857rem;
  min-width: 3.2857142857rem;
}
:host > .flexbox {
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  justify-content: center;
  align-content: flex-start;
  align-items: center;
  height: 100%;
  width: 100%;
}
:host > .flexbox > davinci-icon,
:host > .flexbox > davinci-icon-ref {
  flex: 0 0 auto;
  width: 1.7142857143rem;
  height: 1.7142857143rem;
}
:host > .flexbox > davinci-icon + .slotwrapper ::slotted(*):empty,
:host > .flexbox > davinci-icon-ref + .slotwrapper ::slotted(*):empty {
  display: none;
}
:host > .flexbox > .slotwrapper {
  flex: 0 1 auto;
  overflow: hidden;
  text-overflow: ellipsis;
  margin-left: 0.5714285714rem;
  margin-right: 0.5714285714rem;
}
:host > .flexbox > .slotwrapper ::slotted(*) {
  vertical-align: middle;
  color: #FFFFFF;
  color: var(--davinci-color-text-on-primary, #FFFFFF);
  fill: #FFFFFF;
  fill: var(--davinci-color-text-on-primary, #FFFFFF);
}
:host > .flexbox > .slotwrapper.empty {
  display: none;
}

:host([hidden]) {
  display: none;
}

:host(:empty),
:host(.empty) {
  max-width: 2.8571428571rem;
  padding: 0;
}
:host(:empty) .slotwrapper,
:host(.empty) .slotwrapper {
  display: none;
}

/* STATE: Default */
:host([type=neutral]) {
  background-color: #50585C;
  background-color: var(--davinci-color-dark-gray-3, #50585C);
  border-color: #50585C;
  border-color: var(--davinci-color-dark-gray-3, #50585C);
  color: #FFFFFF;
  color: var(--davinci-color-light, #FFFFFF);
  fill: #FFFFFF;
  fill: var(--davinci-color-light, #FFFFFF);
}
:host([type=neutral]) > .flexbox > .slotwrapper ::slotted(*) {
  color: #FFFFFF;
  color: var(--davinci-color-light, #FFFFFF);
  fill: #FFFFFF;
  fill: var(--davinci-color-light, #FFFFFF);
}

:host([type=accent]) {
  background-color: #F39200;
  background-color: var(--davinci-color-accent, #F39200);
  border-color: #F39200;
  border-color: var(--davinci-color-accent, #F39200);
  color: #FFFFFF;
  color: var(--davinci-color-text-on-accent, #FFFFFF);
  fill: #FFFFFF;
  fill: var(--davinci-color-text-on-accent, #FFFFFF);
}
:host([type=accent]) > .flexbox > .slotwrapper ::slotted(*) {
  color: #FFFFFF;
  color: var(--davinci-color-text-on-accent, #FFFFFF);
  fill: #FFFFFF;
  fill: var(--davinci-color-text-on-accent, #FFFFFF);
}

:host([type=white]) {
  background-color: #FFFFFF;
  background-color: var(--davinci-color-light, #FFFFFF);
  border-color: #FFFFFF;
  border-color: var(--davinci-color-light, #FFFFFF);
  color: #007CC1;
  color: var(--davinci-color-primary, #007CC1);
  fill: #007CC1;
  fill: var(--davinci-color-primary, #007CC1);
}
:host([type=white]) > .flexbox > .slotwrapper ::slotted(*) {
  color: #007CC1;
  color: var(--davinci-color-primary, #007CC1);
  fill: #007CC1;
  fill: var(--davinci-color-primary, #007CC1);
}

:host([type=outline]) {
  background-color: rgba(255, 255, 255, 0);
  color: #007CC1;
  color: var(--davinci-color-primary, #007CC1);
  fill: #007CC1;
  fill: var(--davinci-color-primary, #007CC1);
  border-color: #007CC1;
  border-color: var(--davinci-color-primary, #007CC1);
}
:host([type=outline]) > .flexbox > .slotwrapper ::slotted(*) {
  color: #007CC1;
  color: var(--davinci-color-primary, #007CC1);
  fill: #007CC1;
  fill: var(--davinci-color-primary, #007CC1);
}

:host([type=outline-neutral]) {
  background-color: rgba(255, 255, 255, 0);
  color: #50585C;
  color: var(--davinci-color-dark-gray-3, #50585C);
  fill: #50585C;
  fill: var(--davinci-color-dark-gray-3, #50585C);
  border-color: #50585C;
  border-color: var(--davinci-color-dark-gray-3, #50585C);
}
:host([type=outline-neutral]) > .flexbox > .slotwrapper ::slotted(*) {
  color: #50585C;
  color: var(--davinci-color-dark-gray-3, #50585C);
  fill: #50585C;
  fill: var(--davinci-color-dark-gray-3, #50585C);
}

:host([type=outline-white]) {
  background-color: rgba(255, 255, 255, 0);
  border-color: var(--davinci-white, );
}

:host([type=bare]) {
  background-color: rgba(255, 255, 255, 0);
  border-color: rgba(255, 255, 255, 0);
  fill: #007CC1;
  fill: var(--davinci-color-primary, #007CC1);
  color: #007CC1;
  color: var(--davinci-color-primary, #007CC1);
}
:host([type=bare]) > .flexbox > .slotwrapper ::slotted(*) {
  color: #007CC1;
  color: var(--davinci-color-primary, #007CC1);
  fill: #007CC1;
  fill: var(--davinci-color-primary, #007CC1);
}

:host([type=bare-neutral]) {
  background-color: rgba(255, 255, 255, 0);
  border-color: rgba(255, 255, 255, 0);
  fill: #50585C;
  fill: var(--davinci-color-dark-gray-3, #50585C);
  color: #50585C;
  color: var(--davinci-color-dark-gray-3, #50585C);
}
:host([type=bare-neutral]) > .flexbox > .slotwrapper ::slotted(*) {
  color: #50585C;
  color: var(--davinci-color-dark-gray-3, #50585C);
  fill: #50585C;
  fill: var(--davinci-color-dark-gray-3, #50585C);
}

/* STATE: Hover/Focus */
@media (hover: hover) {
  :host(:hover) {
    background-color: #009DF4;
    background-color: var(--davinci-color-primary-light, #009DF4);
    border-color: #009DF4;
    border-color: var(--davinci-color-primary-light, #009DF4);
  }
}

:host(:not([disabled]):focus-visible) {
  outline-offset: 0.1428571429rem;
  outline: 0.0714285714rem solid var(--davinci-color-primary,#007CC1);
}

@media (hover: hover) {
  :host([type=neutral]:hover) {
    background-color: #737F85;
    background-color: var(--davinci-color-dark-gray-4, #737F85);
    border-color: #737F85;
    border-color: var(--davinci-color-dark-gray-4, #737F85);
    color: #FFFFFF;
    color: var(--davinci-color-light, #FFFFFF);
    fill: #FFFFFF;
    fill: var(--davinci-color-light, #FFFFFF);
  }
  :host([type=neutral]:hover) > .flexbox > .slotwrapper ::slotted(*) {
    color: #FFFFFF;
    color: var(--davinci-color-light, #FFFFFF);
    fill: #FFFFFF;
    fill: var(--davinci-color-light, #FFFFFF);
  }
}

:host([type=neutral]:not([disabled]):focus-visible) {
  outline: 0.0714285714rem solid var(--davinci-color-dark-gray-3,#50585C);
  outline-offset: 0.1428571429rem;
}

@media (hover: hover) {
  :host([type=accent]:hover) {
    background-color: #FFA927;
    background-color: var(--davinci-color-accent-light, #FFA927);
    border-color: #FFA927;
    border-color: var(--davinci-color-accent-light, #FFA927);
    color: #FFFFFF;
    color: var(--davinci-color-text-on-accent-light, #FFFFFF);
    fill: #FFFFFF;
    fill: var(--davinci-color-text-on-accent-light, #FFFFFF);
  }
  :host([type=accent]:hover) > .flexbox > .slotwrapper ::slotted(*) {
    color: #FFFFFF;
    color: var(--davinci-color-text-on-accent-light, #FFFFFF);
    fill: #FFFFFF;
    fill: var(--davinci-color-text-on-accent-light, #FFFFFF);
  }
}

:host([type=accent]:not([disabled]):focus-visible) {
  outline: 0.0714285714rem solid var(--davinci-color-accent,#F39200);
  outline-offset: 0.1428571429rem;
}

@media (hover: hover) {
  :host([type=white]:hover) {
    background-color: #FFFFFF;
    background-color: var(--davinci-color-light, #FFFFFF);
    border-color: #FFFFFF;
    border-color: var(--davinci-color-light, #FFFFFF);
    color: #009DF4;
    color: var(--davinci-color-primary-light, #009DF4);
    fill: #009DF4;
    fill: var(--davinci-color-primary-light, #009DF4);
  }
  :host([type=white]:hover) > .flexbox > .slotwrapper ::slotted(*) {
    color: #009DF4;
    color: var(--davinci-color-primary-light, #009DF4);
    fill: #009DF4;
    fill: var(--davinci-color-primary-light, #009DF4);
  }
}

:host([type=white]:not([disabled]):focus-visible) {
  outline: 0.0714285714rem solid var(--davinci-color-light,#FFFFFF);
  outline-offset: 0.1428571429rem;
}

@media (hover: hover) {
  :host([type=outline]:hover) {
    background-color: #009DF4;
    background-color: var(--davinci-color-primary-light, #009DF4);
    border-color: #009DF4;
    border-color: var(--davinci-color-primary-light, #009DF4);
    color: #FFFFFF;
    color: var(--davinci-color-text-on-primary-light, #FFFFFF);
    fill: #FFFFFF;
    fill: var(--davinci-color-text-on-primary-light, #FFFFFF);
  }
  :host([type=outline]:hover) > .flexbox > .slotwrapper ::slotted(*) {
    color: #FFFFFF;
    color: var(--davinci-color-text-on-primary-light, #FFFFFF);
    fill: #FFFFFF;
    fill: var(--davinci-color-text-on-primary-light, #FFFFFF);
  }
}

:host([type=outline]:not([disabled]):focus-visible) {
  outline: 0.0714285714rem solid var(--davinci-color-primary,#007CC1);
  outline-offset: 0.1428571429rem;
}

@media (hover: hover) {
  :host([type=outline-neutral]:hover) {
    background-color: #737F85;
    background-color: var(--davinci-color-dark-gray-4, #737F85);
    border-color: #737F85;
    border-color: var(--davinci-color-dark-gray-4, #737F85);
    color: #FFFFFF;
    color: var(--davinci-color-light, #FFFFFF);
    fill: #FFFFFF;
    fill: var(--davinci-color-light, #FFFFFF);
  }
  :host([type=outline-neutral]:hover) > .flexbox > .slotwrapper ::slotted(*) {
    color: #FFFFFF;
    color: var(--davinci-color-light, #FFFFFF);
    fill: #FFFFFF;
    fill: var(--davinci-color-light, #FFFFFF);
  }
}

:host([type=outline-neutral]:not([disabled]):focus-visible) {
  outline: 0.0714285714rem solid var(--davinci-color-dark-gray-3,#50585C);
  outline-offset: 0.1428571429rem;
}

@media (hover: hover) {
  :host([type=outline-white]:hover) {
    background-color: #FFFFFF;
    background-color: var(--davinci-color-light, #FFFFFF);
    border-color: #FFFFFF;
    border-color: var(--davinci-color-light, #FFFFFF);
    color: #009DF4;
    color: var(--davinci-color-primary-light, #009DF4);
    fill: #009DF4;
    fill: var(--davinci-color-primary-light, #009DF4);
  }
  :host([type=outline-white]:hover) > .flexbox > .slotwrapper ::slotted(*) {
    color: #009DF4;
    color: var(--davinci-color-primary-light, #009DF4);
    fill: #009DF4;
    fill: var(--davinci-color-primary-light, #009DF4);
  }
}

:host([type=outline-white]:not([disabled]):focus-visible) {
  outline: 0.0714285714rem solid var(--davinci-color-light,#FFFFFF);
  outline-offset: 0.1428571429rem;
}

@media (hover: hover) {
  :host([type=bare]:hover) {
    background-color: rgba(255, 255, 255, 0);
    border-color: rgba(255, 255, 255, 0);
    color: #009DF4;
    color: var(--davinci-color-primary-light, #009DF4);
    fill: #009DF4;
    fill: var(--davinci-color-primary-light, #009DF4);
  }
  :host([type=bare]:hover) > .flexbox > .slotwrapper ::slotted(*) {
    color: var(--davinci-primary-light, );
    fill: var(--davinci-primary-light, );
  }
}

:host([type=bare]:not([disabled]):focus-visible) {
  outline: 0.0714285714rem solid var(--davinci-color-primary,#007CC1);
}

@media (hover: hover) {
  :host([type=bare-neutral]:hover) {
    background-color: rgba(255, 255, 255, 0);
    border-color: rgba(255, 255, 255, 0);
    color: #737F85;
    color: var(--davinci-color-dark-gray-4, #737F85);
    fill: #737F85;
    fill: var(--davinci-color-dark-gray-4, #737F85);
  }
  :host([type=bare-neutral]:hover) > .flexbox > .slotwrapper ::slotted(*) {
    color: #737F85;
    color: var(--davinci-color-dark-gray-4, #737F85);
    fill: #737F85;
    fill: var(--davinci-color-dark-gray-4, #737F85);
  }
}

:host([type=bare-neutral]:not([disabled]):focus-visible) {
  outline: 0.0714285714rem solid var(--davinci-color-dark-gray-4,#737F85);
}

/* STATE: Active */
:host(:active),
:host([selected]) {
  background-color: #005B8E;
  background-color: var(--davinci-color-primary-dark, #005B8E);
  border-color: #005B8E;
  border-color: var(--davinci-color-primary-dark, #005B8E);
  outline: none;
}

:host([type=neutral]:active),
:host([type=neutral][selected]) {
  background-color: #2C3133;
  background-color: var(--davinci-color-dark-gray-2, #2C3133);
  border-color: #2C3133;
  border-color: var(--davinci-color-dark-gray-2, #2C3133);
  color: #FFFFFF;
  color: var(--davinci-color-light, #FFFFFF);
  fill: #FFFFFF;
  fill: var(--davinci-color-light, #FFFFFF);
}
:host([type=neutral]:active) > .flexbox > .slotwrapper ::slotted(*),
:host([type=neutral][selected]) > .flexbox > .slotwrapper ::slotted(*) {
  color: #FFFFFF;
  color: var(--davinci-color-light, #FFFFFF);
  fill: #FFFFFF;
  fill: var(--davinci-color-light, #FFFFFF);
}

:host([type=accent]:active),
:host([type=accent][selected]) {
  background-color: #E36A00;
  background-color: var(--davinci-color-accent-dark, #E36A00);
  border-color: #E36A00;
  border-color: var(--davinci-color-accent-dark, #E36A00);
  color: #FFFFFF;
  color: var(--davinci-color-text-on-accent-dark, #FFFFFF);
  fill: #FFFFFF;
  fill: var(--davinci-color-text-on-accent-dark, #FFFFFF);
}
:host([type=accent]:active) > .flexbox > .slotwrapper ::slotted(*),
:host([type=accent][selected]) > .flexbox > .slotwrapper ::slotted(*) {
  color: #FFFFFF;
  color: var(--davinci-color-text-on-accent-dark, #FFFFFF);
  fill: #FFFFFF;
  fill: var(--davinci-color-text-on-accent-dark, #FFFFFF);
}

:host([type=white]:active),
:host([type=white][selected]) {
  background-color: #FFFFFF;
  background-color: var(--davinci-color-light, #FFFFFF);
  border-color: #FFFFFF;
  border-color: var(--davinci-color-light, #FFFFFF);
  color: #005B8E;
  color: var(--davinci-color-primary-dark, #005B8E);
  fill: #005B8E;
  fill: var(--davinci-color-primary-dark, #005B8E);
}
:host([type=white]:active) > .flexbox > .slotwrapper ::slotted(*),
:host([type=white][selected]) > .flexbox > .slotwrapper ::slotted(*) {
  color: #005B8E;
  color: var(--davinci-color-primary-dark, #005B8E);
  fill: #005B8E;
  fill: var(--davinci-color-primary-dark, #005B8E);
}

:host([type=outline]:active),
:host([type=outline][selected]) {
  background-color: #005B8E;
  background-color: var(--davinci-color-primary-dark, #005B8E);
  border-color: #005B8E;
  border-color: var(--davinci-color-primary-dark, #005B8E);
  color: #FFFFFF;
  color: var(--davinci-color-text-on-primary-dark, #FFFFFF);
  fill: #FFFFFF;
  fill: var(--davinci-color-text-on-primary-dark, #FFFFFF);
}
:host([type=outline]:active) > .flexbox > .slotwrapper ::slotted(*),
:host([type=outline][selected]) > .flexbox > .slotwrapper ::slotted(*) {
  color: #FFFFFF;
  color: var(--davinci-color-text-on-primary-dark, #FFFFFF);
  fill: #FFFFFF;
  fill: var(--davinci-color-text-on-primary-dark, #FFFFFF);
}

:host([type=outline-neutral]:active),
:host([type=outline-neutral][selected]) {
  background-color: #2C3133;
  background-color: var(--davinci-color-dark-gray-2, #2C3133);
  border-color: #2C3133;
  border-color: var(--davinci-color-dark-gray-2, #2C3133);
  color: #FFFFFF;
  color: var(--davinci-color-light, #FFFFFF);
  fill: #FFFFFF;
  fill: var(--davinci-color-light, #FFFFFF);
}
:host([type=outline-neutral]:active) > .flexbox > .slotwrapper ::slotted(*),
:host([type=outline-neutral][selected]) > .flexbox > .slotwrapper ::slotted(*) {
  color: #FFFFFF;
  color: var(--davinci-color-light, #FFFFFF);
  fill: #FFFFFF;
  fill: var(--davinci-color-light, #FFFFFF);
}

:host([type=outline-white]:active),
:host([type=outline-white][selected]) {
  background-color: #FFFFFF;
  background-color: var(--davinci-color-light, #FFFFFF);
  border-color: #FFFFFF;
  border-color: var(--davinci-color-light, #FFFFFF);
  color: #005B8E;
  color: var(--davinci-color-primary-dark, #005B8E);
  fill: #005B8E;
  fill: var(--davinci-color-primary-dark, #005B8E);
}
:host([type=outline-white]:active) > .flexbox > .slotwrapper ::slotted(*),
:host([type=outline-white][selected]) > .flexbox > .slotwrapper ::slotted(*) {
  color: #005B8E;
  color: var(--davinci-color-primary-dark, #005B8E);
  fill: #005B8E;
  fill: var(--davinci-color-primary-dark, #005B8E);
}

:host([type=bare]:active),
:host([type=bare][selected]) {
  background-color: rgba(255, 255, 255, 0);
  border-color: rgba(255, 255, 255, 0);
  color: #005B8E;
  color: var(--davinci-color-primary-dark, #005B8E);
  fill: #005B8E;
  fill: var(--davinci-color-primary-dark, #005B8E);
}
:host([type=bare]:active) > .flexbox > .slotwrapper ::slotted(*),
:host([type=bare][selected]) > .flexbox > .slotwrapper ::slotted(*) {
  color: var(--davinci-primary-dark, );
  fill: var(--davinci-primary-dark, );
}

:host([type=bare-neutral]:active),
:host([type=bare-neutral][selected]) {
  background-color: rgba(255, 255, 255, 0);
  border-color: rgba(255, 255, 255, 0);
  color: #2C3133;
  color: var(--davinci-color-dark-gray-2, #2C3133);
  fill: #2C3133;
  fill: var(--davinci-color-dark-gray-2, #2C3133);
}
:host([type=bare-neutral]:active) > .flexbox > .slotwrapper ::slotted(*),
:host([type=bare-neutral][selected]) > .flexbox > .slotwrapper ::slotted(*) {
  color: #2C3133;
  color: var(--davinci-color-dark-gray-2, #2C3133);
  fill: #2C3133;
  fill: var(--davinci-color-dark-gray-2, #2C3133);
}

/* STATE: Disabled */
:host([disabled]) {
  pointer-events: none;
  cursor: default;
}

:host([disabled]) {
  background-color: #C5CACC;
  background-color: var(--davinci-color-outline-light, #C5CACC);
  border-color: #C5CACC;
  border-color: var(--davinci-color-outline-light, #C5CACC);
  color: #B1B8BC;
  color: var(--davinci-color-text-disabled, #B1B8BC);
  fill: #B1B8BC;
  fill: var(--davinci-color-text-disabled, #B1B8BC);
}
:host([disabled]) > .flexbox > .slotwrapper ::slotted(*) {
  color: #B1B8BC;
  color: var(--davinci-color-text-disabled, #B1B8BC);
  fill: #B1B8BC;
  fill: var(--davinci-color-text-disabled, #B1B8BC);
}

:host([type=white][disabled]) {
  background-color: #FFFFFF;
  background-color: var(--davinci-color-light, #FFFFFF);
  border-color: #FFFFFF;
  border-color: var(--davinci-color-light, #FFFFFF);
  color: #B1B8BC;
  color: var(--davinci-color-text-disabled, #B1B8BC);
  fill: #B1B8BC;
  fill: var(--davinci-color-text-disabled, #B1B8BC);
}
:host([type=white][disabled]) > .flexbox > .slotwrapper ::slotted(*) {
  color: #B1B8BC;
  color: var(--davinci-color-text-disabled, #B1B8BC);
  fill: #B1B8BC;
  fill: var(--davinci-color-text-disabled, #B1B8BC);
}

:host([type=outline][disabled]),
:host([type=outline-neutral][disabled]),
:host([type=outline-white][disabled]) {
  background-color: rgba(255, 255, 255, 0);
  color: #B1B8BC;
  color: var(--davinci-color-text-disabled, #B1B8BC);
  fill: #B1B8BC;
  fill: var(--davinci-color-text-disabled, #B1B8BC);
  border-color: var(--davinci-color-outline-disabled, );
}
:host([type=outline][disabled]) > .flexbox > .slotwrapper ::slotted(*),
:host([type=outline-neutral][disabled]) > .flexbox > .slotwrapper ::slotted(*),
:host([type=outline-white][disabled]) > .flexbox > .slotwrapper ::slotted(*) {
  color: #B1B8BC;
  color: var(--davinci-color-text-disabled, #B1B8BC);
  fill: #B1B8BC;
  fill: var(--davinci-color-text-disabled, #B1B8BC);
}

:host([type=bare][disabled]),
:host([type=bare-neutral][disabled]) {
  background-color: rgba(255, 255, 255, 0);
  border-color: rgba(255, 255, 255, 0);
  color: #B1B8BC;
  color: var(--davinci-color-text-disabled, #B1B8BC);
  fill: #B1B8BC;
  fill: var(--davinci-color-text-disabled, #B1B8BC);
}
:host([type=bare][disabled]) > .flexbox > .slotwrapper ::slotted(*),
:host([type=bare-neutral][disabled]) > .flexbox > .slotwrapper ::slotted(*) {
  color: #B1B8BC;
  color: var(--davinci-color-text-disabled, #B1B8BC);
  fill: #B1B8BC;
  fill: var(--davinci-color-text-disabled, #B1B8BC);
}

:host(:after) {
  content: "";
  position: absolute;
  width: 100%;
  height: 100%;
  left: 0;
  top: 0;
  background: rgba(255, 255, 255, 0);
}`;
export { style };
